"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkClientFetchError = void 0;
// An error response (from fastify / http errors looks like this)
class NetworkClientFetchError extends Error {
    constructor(statusCode, url, message, responseBody) {
        super(message);
        this.statusCode = statusCode;
        this.url = url;
        this.message = message;
        this.responseBody = responseBody;
    }
}
exports.NetworkClientFetchError = NetworkClientFetchError;
